import { useState, useEffect, useRef, useCallback } from 'react';
import { fieldSubscriptionItems, createForm, formSubscriptionItems } from 'final-form';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var all = fieldSubscriptionItems.reduce(function (result, key) {
  result[key] = true;
  return result;
}, {});
var useField = function useField(name, form, subscription) {
  var _useState = useState({}),
    state = _useState[0],
    setState = _useState[1];
  useEffect(function () {
    return form.registerField(name, setState, subscription || all);
  }, [name, subscription]);
  var _ref = state || {},
    blur = _ref.blur,
    change = _ref.change,
    focus = _ref.focus,
    value = _ref.value,
    meta = _objectWithoutPropertiesLoose(_ref, ["blur", "change", "focus", "value"]);
  delete meta.name; // it's in input

  return {
    input: {
      name: name,
      value: value || '',
      onBlur: function onBlur() {
        return state.blur();
      },
      onChange: function onChange(event) {
        return state.change(event.target.value);
      },
      onFocus: function onFocus() {
        return state.focus();
      }
    },
    meta: meta
  };
};
var all$1 = formSubscriptionItems.reduce(function (result, key) {
  result[key] = true;
  return result;
}, {});
var useForm = function useForm(_ref) {
  var subscription = _ref.subscription,
    config = _objectWithoutPropertiesLoose(_ref, ["subscription"]);
  var form = useRef(createForm(config));
  var _useState = useState({}),
    state = _useState[0],
    setState = _useState[1];
  useEffect(function () {
    return form.current.subscribe(setState, subscription || all$1);
  }, [subscription]);
  var handleSubmit = useCallback(function (event) {
    if (event) {
      if (typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
      if (typeof event.stopPropagation === 'function') {
        event.stopPropagation();
      }
    }
    return form.current.submit();
  }, []);
  return _extends({}, state, {
    form: form.current,
    handleSubmit: handleSubmit
  });
};
export { useField, useForm };